import dynamic from 'next/dynamic'
import { Map } from '@emotion-icons/fa-solid/Map'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/generic-map-backdrop.png'

const InsightMap = dynamic(() => import('src/components/insight-map'), { ssr: false })
type RemoveType = Omit<InsightBuilderWidget, 'type'>
type TextOnlyWidget = RemoveType & { type: 'Map' }

export const InsightMapWidget: Readonly<TextOnlyWidget> = {
  id: 'insight-map',
  name: 'Map',
  type: 'Map',
  icon: Map,
  component: InsightMap as any,
  preview,
  supportedResultTypes: [],
} as const
